<rask-page
  pageTitle="Sök certifikat"
  noPadding
  actionTitle="Lägg till certifikat"
  [actionShow]="true"
  [actionFn]="onCreate.bind(this)">
  <ng-container headerContent>
    <form [formGroup]="form" (ngSubmit)="onSearch()">
      <div class="row">
        <rask-input class="col-2"
          label="Certifikatsnummer"
          formControlName="certifikatsnummer">
        </rask-input>
        <rask-tree-selector class="col-2"
          label="Certifikatstyp"
          formControlName="certifikatstyp"
          [items]="certifikatstyper"
          [autoSort]="false">
        </rask-tree-selector>
        <rask-input class="col-2"
          label="Ägare"
          formControlName="agare">
        </rask-input>
        <rask-radiobutton-group class="col-2"
          label="Sveaskog"
          formControlName="sveaskog"
          [buttons]="radioButtonOptions">
        </rask-radiobutton-group>
        <rask-radiobutton-group class="col-2"
          label="Aktiv"
          formControlName="aktiv"
          [buttons]="radioButtonOptions">
        </rask-radiobutton-group>
        <rask-submit-button class="col-2">Sök</rask-submit-button>
      </div>
      <div class="row">
        <rask-datepicker-interval class="col-5"
          labelStartDate="Giltighetstid f.r.o.m"
          labelEndDate="Giltighetstid t.o.m"
          (startDate)="setFrom($event)"
          (endDate)="setTom($event)"
        ></rask-datepicker-interval>
      </div>
    </form>
  </ng-container>
  <rask-list [data]="certifikat$ | async">
    <rask-list-column header="Certifikatsnummer" field="certifikatsnummer" [sortable]="true">
      <ng-template let-row="row" let-value>
        <a href="#" (click)="onOpen($event, row)">{{value}}</a>
      </ng-template>
    </rask-list-column>
    <rask-list-column header="Visa kontrakt">
      <ng-template let-row="row">
        @if (row.antalKontrakt !== 0 && kanVisaKontrakt()) {
          <a href="#" (click)="visaKontrakt($event, row)">
            <rask-icon  negative icon="far fa-handshake fa-lg"></rask-icon>
            Antal kontrakt: {{row.antalKontrakt}}
          </a>
        }
        @if (row.antalKontrakt === 0 || !kanVisaKontrakt()) {
          <span>
            <rask-icon  negative icon="far fa-handshake fa-lg"></rask-icon>
            Antal kontrakt: {{row.antalKontrakt}}
          </span>
        }
      </ng-template>
    </rask-list-column>
    <rask-list-column header="Certifikatstyp" field="certifikatstyp" [sortable]="true">
    </rask-list-column>
    <rask-list-column header="Ägare" field="agare" [sortable]="true">
    </rask-list-column>
    <rask-list-column header="Sveaskog" field="sveaskog" [sortable]="true">
      <ng-template let-value>
        @if (value) {
          <i class="far fa-check"></i>
        }
      </ng-template>
    </rask-list-column>
    <rask-list-column header="Giltig t.o.m" field="giltigTom" [sortable]="true">
      <ng-template let-value>
        {{value | date:'yyyy-MM-dd'}}
      </ng-template>
    </rask-list-column>
    <rask-list-column header="Aktiv" field="aktiv" [sortable]="true">
      <ng-template let-value>
        @if (value) {
          <i class="far fa-check"></i>
        }
      </ng-template>
    </rask-list-column>
    <rask-list-column header="Ta bort">
      <ng-template let-row="row">
        @if (row.canDelete) {
          <div>
            <rask-icon-button (click)="onDelete(row)" negative icon="far fa-trash-alt fa-lg">
            </rask-icon-button>
          </div>
        }
      </ng-template>
    </rask-list-column>
  </rask-list>
</rask-page>